"use client";

import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "fumadocs-ui/components/ui/popover";
import { buttonVariants } from "fumadocs-ui/components/ui/button";
import { ChevronDown, ExternalLink } from "lucide-react";

export function PageOpenMenu({
  markdownUrl,
  pageUrl,
}: {
  markdownUrl: string;
  pageUrl: string;
}) {
  const prompt = `Read ${typeof window === "undefined" ? pageUrl : new URL(pageUrl, window.location.origin)}, I want to ask questions about it.`;
  const links = [
    { label: "View as Markdown", href: markdownUrl },
    {
      label: "Open in ChatGPT",
      href: `https://chatgpt.com/?${new URLSearchParams({ hints: "search", q: prompt })}`,
    },
    {
      label: "Open in Claude",
      href: `https://claude.ai/new?${new URLSearchParams({ q: prompt })}`,
    },
    {
      label: "Open in Cursor",
      href: `https://cursor.com/link/prompt?${new URLSearchParams({ text: prompt })}`,
    },
  ];

  return (
    <Popover>
      <PopoverTrigger
        className={`${buttonVariants({ color: "secondary", size: "sm" })} gap-2`}
      >
        Open
        <ChevronDown className="size-3.5 text-fd-muted-foreground" />
      </PopoverTrigger>
      <PopoverContent className="flex flex-col">
        {links.map(({ label, href }) => (
          <a
            key={label}
            href={href}
            target="_blank"
            rel="noreferrer noopener"
            className="inline-flex items-center gap-2 rounded-lg p-2 text-sm hover:bg-fd-accent hover:text-fd-accent-foreground"
          >
            {label}
            <ExternalLink className="ms-auto size-3.5 text-fd-muted-foreground" />
          </a>
        ))}
      </PopoverContent>
    </Popover>
  );
}
